module.exports = __webpack_public_path__ + "img/login-logo-wuhan.1cc4652b.png";